import styled, { css } from 'styled-components';

export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-m3yivz-0" })(["", ""],
({ disabled }) =>
disabled &&
css(["opacity:0.6;pointer-events:none;"]));





export const RadioInput = /*#__PURE__*/styled.input.withConfig({ displayName: "styles__RadioInput", componentId: "sc-m3yivz-1" })(["height:0;width:0;position:absolute;&:checked ~ div:after{position:absolute;content:'';width:10px;height:10px;background:", ";border-radius:50%;}"],









({ theme, dotColor }) =>
dotColor || theme.colors.Foreground);




export const Dot = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Dot", componentId: "sc-m3yivz-2" })(["position:relative;border:1px solid ", ";box-sizing:border-box;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;"],


({ theme, borderColor }) =>
borderColor || theme.colors['Level 2']);










export const Label = /*#__PURE__*/styled.label.withConfig({ displayName: "styles__Label", componentId: "sc-m3yivz-3" })(["display:flex;flex-wrap:nowrap;align-items:center;"]);





export const Text = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__Text", componentId: "sc-m3yivz-4" })(["", ";margin-left:8px;"],
(props) => css(props.theme.typography.Paragraph));